export enum UnitDocumentStatus {
  Invalid = -1,
  /** Not a real status in Unit */
  None = 0,
  Approved = 1,
  Required = 2,
  ReceivedFront = 3,
  ReceivedBack = 4,
  PendingReview = 5,
}

// tslint:disable-next-line:no-namespace
export namespace UnitDocumentStatus {
  export function toString(enumValue: UnitDocumentStatus): string {
    switch (enumValue) {
      case UnitDocumentStatus.Invalid:
        return 'Invalid';
      case UnitDocumentStatus.None:
        return null;
      case UnitDocumentStatus.Approved:
        return 'Approved';
      case UnitDocumentStatus.Required:
        return 'Required';
      case UnitDocumentStatus.ReceivedFront:
        return 'Received Front';
      case UnitDocumentStatus.ReceivedBack:
        return 'Received Back';
      case UnitDocumentStatus.PendingReview:
        return 'Pending Review';
      default:
        return null;
    }
  }

  export function listAll() {
    return [
      UnitDocumentStatus.Invalid,
      UnitDocumentStatus.Approved,
      UnitDocumentStatus.Required,
      UnitDocumentStatus.ReceivedFront,
      UnitDocumentStatus.ReceivedBack,
      UnitDocumentStatus.PendingReview,
    ];
  }

  export function parse(str: string): UnitDocumentStatus {
    return UnitDocumentStatus[str];
  }
}

export default UnitDocumentStatus;
